module.exports = __webpack_public_path__ + "img/cx.cb15cb04.svg";